import { request } from '@/util/http'

export const getList = (current, size, params) => {
  return request({
    url: '/process/leave/list',
    method: 'get',
    params: {
      ...params,
      current,
      size
    }
  })
}

export const getDetail = (id) => {
  return request({
    url: '/process/leave/detail',
    method: 'get',
    params: {
      id
    }
  })
}

export const remove = (ids) => {
  return request({
    url: '/process/leave/remove',
    method: 'post',
    params: {
      ids
    }
  })
}

export const submit = (row) => {
  return request({
    url: '/process/leave/submit',
    method: 'post',
    data: row
  })
}

export const startProcess = (data) => {
  return request({
    url: '/process/leave/start-process',
    method: 'post',
    data
  })
}
